<template>
<!-- 物料管理 -->
  <div class="materials">
    <ab-list-query :tabs="tabs" @handleTabs='selectMenu' isActive='0'>
      <template #right>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              placeholder="型号"
              v-model.trim="formSearch.itemCode"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              placeholder="品牌" 
              v-model.trim="formSearch.brandName"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
             <el-input
              placeholder="物料名称"
              v-model.trim="formSearch.itemName"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <ab-timeSearch
              class="searchBox"
              startSrc="创建日期起"
              endSrc="创建日期止"
              v-model="formSearch.timeRange"
              @searchEvent="changeTimeRange"
            ></ab-timeSearch>
          </el-col>
          <el-col :span="4" class="text-left">
            <el-button @click="searchForm">搜索</el-button>
            <el-button link class="btn-svg" @click="formSearch={}"><ab-svg name="qingchu"></ab-svg>清除</el-button>
          </el-col>
        </el-row>
      </template>

      <template #toolbar>
        <el-button type="primary" @click="addHandlerEdit">新增</el-button>
        <el-button :loading="btnsLoading.classify"  @click="classification" :disabled="classifieState">我要归类</el-button>
        <ab-fileBtn multiple class="multiUpload" v-model="fileData" url="/oms/billAttach/batchUploadFile"
            :mustId="false"
            fileKey="upFiles"
            @change="localSearch"
            text="上传附件"
        ></ab-fileBtn>
        <el-button :loading="btnsLoading.remove" @click="removeRow">批量删除</el-button>
        
        <el-button :loading="btnsLoading.download" @click="downloadFile">下载模板</el-button>

        <ab-fileBtn
            class="multiUpload"
            v-model="fileData"
            @change="localSearch"
            icon="el-icon-daoru"
            text="导入"
            url="/wmsbase/client/clientItemPrincipal/batchImport"
        ></ab-fileBtn>
        <el-button  :loading="btnsLoading.export" @click="exportFile">导出</el-button>
      </template>

      <template #table>
        <ab-table
          class="materialTable"
          ref="table"
          stripe
          showEdit
          showSelection
          selectionWidth="45"
          indexWidth="50"
          widths="180"
          isFilter="operator"
          :column-list="columns"
          :table-list="tableData"
          :dataListLoading="btnsLoading.table"
          :handleSelectionChange="handleSelectionChange"
          @filterColumns="filterColumns"
        >
          <template #classifyStatusDesc="scope">
            <div>
              <span :class="getStatusClass(scope.row.classifyStatusDesc)"></span>
              {{ scope.row.classifyStatusDesc }}
            </div>
          </template>

          <template #operator="scope">
            <el-button type="primary" link @click="showDialog(scope.row)">编辑</el-button>
            <!-- <i class="dividingLine"></i> -->
            <el-button type="primary" link class="redBtn" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </ab-table>
      </template>

      <template #page>
        <ab-page
          :pageTotal="pages.total"
          :currentPage="pages.currentPage"
          :pageSize="pages.pageSize"
          :pageSizes="pages.pageSizes"
          @searchForm="pageSearch"
        ></ab-page>
      </template>
    </ab-list-query>

    <!-- 新增抽屉 -->
    <div class="materialsAdd">
      <el-drawer v-model="drawer" :show-close="false" @close='handleClose'>
        <template #header="{ close }">
          <h4 v-if="editOrAdd">新增物料</h4>
          <h4 v-if="!editOrAdd">编辑物料</h4>
          <button
            aria-label="el.drawer.close"
            class="el-drawer__close-btn"
            type="button"
            @click="close"
          >
            <i class="el-icon el-drawer__close">
              <el-icon>
                <CircleCloseFilled />
              </el-icon>
            </i>
          </button>
        </template>

        <div class="banner">
            
            <el-alert title="未归类的物料请提供产品规格书或图片" type="warning" class="materialsAlert"/>
            
          <el-form
            :model="dataForm"
            ref="dataFrom"
            label-position="top"
            :rules="rules"
            v-loading="btnsLoading.editLoading"
          >
            <el-form-item label="物料型号" :required="true" prop="itemCode">
               <el-autocomplete
                    v-model="dataForm.itemCode"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入物料型号"
                    @select="itemCodeSelect"
                    @change="itemCodeBlur"
                    clearable
                >
                <template #default="{ item }">
                  <span class="addr">{{ item.concatStr }}</span>
                </template>
              </el-autocomplete>
            </el-form-item>

            <el-form-item label="物料品牌" prop="brandName">
              <el-input v-model="dataForm.brandName" placeholder="请输入物料品牌" />
            </el-form-item>

            <el-form-item label="物料名称" prop="itemName">
                <el-input v-model="dataForm.itemName" placeholder="请输入名称" />
            </el-form-item>

            <el-form-item label="料号" prop="clientNumber" :rules="[
                { required: dataForm.itemCode === '无型号' && !drawerData.isSelect, message: '请输入料号', trigger: 'blur' },
                { max: 50, message: '最大支持50位字符', trigger: 'blur' }
              ]">
              <el-input v-model="dataForm.clientNumber" placeholder="请输入料号"/>
            </el-form-item>

            <el-form-item label="单位" prop="itemUnitName">
                <ab-select
                    url="/bas/basMeasureUnit/list"
                    placeholder="请输入单位"
                    inputKey="name"
                    descKey="name"
                    v-model="dataForm.itemUnitName"
                    :urlData="{isNeedFilter:true , isEnabled:1, pageSize: 10, pageNum: 1}"
                    @handleSelect="itemItemUnitName"
                >
                </ab-select>
            </el-form-item>

            <el-form-item label="产地">
                <ab-select
                    url="/bas/basArea/listCountry"
                    placeholder="请输入产地"
                    inputKey="keyWord"
                    descKey="label"
                    v-model="dataForm.originPlaceName"
                    :urlData="{type:1,isEnabled:1, pageSize: 10, pageNum: 1}"
                    @handleSelect="changOriginPlaceName"
                >
                </ab-select>
            </el-form-item>

            <el-form-item label="单价">
              <el-input v-model="dataForm.price" placeholder="请输入单价" />
            </el-form-item>

            <el-form-item label="产品参数" style="margin-bottom: 20px">
              <el-input
                v-model="dataForm.productSpec"
                placeholder="请输入产品参数"
              />
            </el-form-item>

            <el-form-item>
                <ab-upload :params="uploadParams" @update-billsId="getTempBillId"></ab-upload>
            </el-form-item>

          </el-form>
        </div>

        <template #footer>
          <div style="flex: auto">
            <el-button @click="drawer=false">取消</el-button>
            <el-button
              type="primary"
              style="margin-left: 20px"
              @click="submitForm"
              :loading="btnsLoading.btnLoading"
              >确定</el-button
            >
          </div>
        </template>
      </el-drawer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'material-management',
  data() {
    return {
        editOrAdd:null,//1为新增地址，其余为修改
        receiptAndDelivery:'',//当前状态,全部或未归类
        tabs: [
            { name: "全部", value: "", state: "0" },
            { name: "未归类", value: "", state: "1" },
            { name: "归类中", value: "", state: "2" },
            { name: "已归类", value: "", state: "3" },
        ],
        // 状态汇总
        btnsLoading: {
            table: false,
            download: false,
            export: false,
            classify: false,
            remove: false,
            editLoading:false,
            btnLoading:false
        },
        formSearch: {}, //搜索参数
        dateTimeRange: "",
        columns: [
            {
            props: "materielNumber",
            labels: "物料编号",
            widths: 90,
            },
            {
            props: "createTime",
            labels: "创建时间",
            widths: 100,
            },
            {
            props: "classifyStatusDesc",
            labels: "归类状态",
            widths: 80,
            slot: "slot",
            },
            {
            props: "itemCode",
            labels: "型号",
            widths: 80,
            },
            {
            props: "brandName",
            labels: "品牌",
            widths: 80,
            },
            {
            props: "itemName",
            labels: "物料名称",
            widths: 80,
            },

            {
            props: "clientNumber",
            labels: "料号",
            widths: 100,
            },
            {
            props: "itemUnitName",
            labels: "单位",
            widths: 50,
            },

            {
            props: "enterShutTaxRate",
            labels: "关税",
            widths: 50,
            },
            {
            props: "exitRetreatTaxRate",
            labels: "退税",
            widths: 50,
            },
            {
            props: "customsSupervisionDesc",
            labels: "海关监管条件",
            widths: 90,
            },
            {
            props: "inspectionQuarantineDesc",
            labels: "检验检疫类型",
            widths: 90,
            },
        ],
        pages: {
            currentPage: 1, //当前页
            pageSize: 10, //每页展示的数据个数
            pageSizes: [10, 20, 50, 100],
            total: 100,
        },
        //列表数据
        tableData: [],
        isloading: false,
        //抽屉
        drawer: false,
        dataForm: {},
        //抽屉数据
        drawerData: {
            show: false,
            btnLoading: false,
            isSelect: false,
            data: {},
        },
        //抽屉上传附件
        uploadParams: {
            coreBillIds: "",
            coreBillNumbers: "",
            sourceBillId: "",
            sourceBillNumber: "",
            sourceBillType: "ItemPrincipal",
            billsType: "",
            items : [
                {
                    title: "附件",
                    attachType: "010",
                    required: false,
                    message: "PI/INVOICE"
                }
            ]
        },
        // 选择的itemCode
        selectItemCode: '',
        //选择行
        multiSelected:[],
        // 附件数据
        fileData: {
            sourceBillId: '',
            attachType: '010',
            sourceBillType: 'ItemPrincipal',
            sourceBillNumber: ''
        },
        // 已上传文件列表
        uploadList: [],
        //验证规则
        rules: {
            itemCode: [
            { required: true, message: "请输入物料型号", trigger: "blur" },
            ],
            itemUnitName: [{ required: true, message: "请选择单位", trigger: ["change", "blur"]}],
            brandName: [{ required: true, message: "请输入物料品牌", trigger: "blur" }],
            itemName: [{ required: true, message: "请输入物料名称", trigger: "blur" }],
        },
    };
  },
  computed: {
    classifieState () {      
        if (this.multiSelected.length === 0) {
            return true
        }
        let flag = false
        this.multiSelected.map(row => {
            if (['已归类', '待归类'].includes(row.classifyStatusDesc)) {
            flag = true
            }
        })
        return flag
    }
  },
  methods: {
    localSearch(){
        this.getListData()
    },
    //弹窗关闭清除数据
    handleClose(){
        this.dataForm={}
        this.$refs.dataFrom.resetFields()
        this.uploadParams = {
            coreBillIds: "",
            coreBillNumbers: "",
            sourceBillId: "",
            sourceBillNumber: "",
            sourceBillType: "ItemPrincipal",
            billsType: "",
            items : [
                {
                    title: "附件",
                    attachType: "010",
                    required: false,
                    message: "PI/INVOICE"
                }
            ]
        }
    },
    //翻页
    pageSearch(obj) {
      this.pages.currentPage = obj.currentPage;
      this.pages.pageSize = obj.pageSize;
      this.getListData();
    },
    //归类状态判断条件
    getStatusClass(val) {
      let cls = "";
      switch (val) {
        case "未归类":
            cls = "status-E21010";
        break;
        case "归类中":
            cls = "status-FF8400";
        break;
        case "已归类":
            cls = "status-0AB2A8";
        break;
        case "待确认":
            cls = "status-B1B1B1";
        break;
      }
      return cls;
    },
    //筛选列表字段
    filterColumns(array) {
      this.columns = array;
    },
    //搜索
    searchForm(){
        this.getListData()
    },
    //选择行
    handleSelectionChange(arr){
        this.multiSelected = arr
    },
    //抽屉表单校验规则
    submitForm() {
      this.$refs.dataFrom.validate((valid) => {
        if (valid) {
            this.btnsLoading.btnLoading=true
             this.$post('/wmsbase/client/clientItemPrincipal/' + (this.dataForm.id ? 'mod' : 'add'), this.dataForm)
            .then(({ data }) => {
              if (data.code === 'C0000') {
                this.$message({type: 'success', message: data.message, offset: 380, grouping: true})
                
                this.drawer = false
                this.getListData()
              }
            })
            .finally(() => {
              this.btnsLoading.btnLoading=false
            })
        }
      });
    },
    //日期
    changeTimeRange (obj) {
        this.formSearch.timeRange=obj
        if (obj) {
            this.formSearch.updateTimeStart = obj[0]
            this.formSearch.updateTimeEnd = obj[1]
        } else {
            this.formSearch.updateTimeStart = ''
            this.formSearch.updateTimeEnd = ''
        }
        this.getListData()
    },
    //获取数据
    getListData () {
        let data = Object.assign({}, { pageNum: this.pages.currentPage, pageSize:this.pages.pageSize }, this.formSearch)
        // if (data.timeRange && data.timeRange.length) {
            data.updateTimeBegin = this.formSearch.updateTimeStart
            data.updateTimeEnd = this.formSearch.updateTimeEnd
        // }
        data.classifyStatus=this.receiptAndDelivery
        if (this.btnsLoading.export) {
            data.excelField = this.columns.map(column => { return column.props })
            data.colTitleMapList = this.columns
            this.$post('/wmsbase/client/clientItemPrincipal/expList', data)
            .then(({ data }) => {
                if (data.code === 'C0000') {
                    this.$message({type: 'success', message: data.message, offset: 380, grouping: true})
                    window.open(data.result)
                }
            })
            .finally(() => {
                this.btnsLoading.export = false
            })
        } else {
            this.btnsLoading.table = true
            this.$post('/wmsbase/client/clientItemPrincipal/pageList', data)
            .then(({ data }) => {
                if (data.code === 'C0000') {
                // this.tabs.forEach(ele=>{
                //   if((ele.classifyStatus == this.formSearch.classifyStatus) && this.formSearch.classifyStatus) {
                //     ele.value = data.result.total
                //   }
                // })
                this.tableData = data.result.list
                this.pages.total = data.result.total
                this.receiptAndDeliveryNumber(data.extra)
                }
            })
            .finally(() => {
                this.btnsLoading.table = false
            })
        }
    },
    //菜单
    selectMenu(index){   
        console.log(index);
        this.formSearch={}
        this.receiptAndDelivery=''
        this.receiptAndDelivery=index
        if(index==0){
            this.receiptAndDelivery=''
        } 
        this.getListData()
    },
    receiptAndDeliveryNumber(val){
        this.tabs.forEach(item =>{
            if(item.state == '1'){
                item.value = val['1']
            }else if(item.state == '2'){
                item.value = val['2']
            }
        })
    },
    //编辑
    showDialog(row){
        this.drawer=true
        this.btnsLoading.editLoading=true
        this.editOrAdd=false
        
        this.$get('/wmsbase/client/clientItemPrincipal/get', { id: row.id }).then(({ data }) => {
            this.drawerData.selecting=true
            this.dataForm = data.result
            this.dataForm.originPlaceName=data.result.originPlaceName
            this.fileData.sourceBillId = this.dataForm.id
            this.fileData.sourceBillIdList = [this.dataForm.id]
            this.uploadParams.sourceBillId=this.dataForm.id
            this.uploadParams.sourceBillIdList=[this.dataForm.id]
            setTimeout(() => {
                    this.drawerData.selecting=false
            }, 200)
            this.$post('/oms/billAttach/queryBySourceData', this.fileData).then(({ data }) => {
              if (data.code === 'C0000') {
                this.uploadList = data.result['010'] || []
              }
            }).finally(() => {
                this.btnsLoading.editLoading=false
            })
        })
    },
    //新增
    addHandlerEdit(){
        this.drawer=true
        this.editOrAdd=true
    },
    // 物料型号变更规则：单独输入“无”或“无型”，强制修正为“无型号
    itemCodeBlur () {
        if (!this.drawerData.isSelect) {
        if (['无', '无型'].includes(this.dataForm.itemCode)) {
          this.dataForm.itemCode='无型号'
        }
        this.$refs.dataFrom.clearValidate('clientNumber')
      }
    },
    //物料型号远程搜索
    querySearchAsync (queryString, callback) {
        console.log(queryString);
        let data = {
            'isPage': true,
            'itemCodeLike': queryString,
            'status': 1
        }
        let results = []
        this.$post('/wmsbase/item/pageListByKey', data).then(({ data }) => {
            if (data.code === 'C0000') {
                results = data.result.list
            }
            })
            .finally(() => {
            callback(results)
            })
    },
    // 过滤条件选择，点击物料型号建议触发此事件
    itemCodeSelect (item) {
        this.selectItemCode = item.itemCode
        this.drawerData.isSelect=true
        this.drawerData.selecting=true
        this.dataForm.brandName=item.brandName
        this.dataForm.itemCode=item.itemCode
        this.dataForm.itemName=item.itemName

        if (item.itemUnit !== 'Pcs') {
            this.dataForm.itemUnitId=item.itemUnitId
            this.dataForm.itemUnitName=item.itemUnit
        }
        this.dataForm.clientNumber=item.clientNumber
        this.dataForm.relateItemId=item.id

        this.$refs.dataFrom.validateField('itemCode')
        setTimeout(() => {
            this.drawerData.selecting=false
        }, 200)
    },
    //删除行
    removeRow () {
        this.$confirm(`确定删除选中数据？`, '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.btnsLoading.remove = true
            this.$post('/wmsbase/client/clientItemPrincipal/delByIds', { ids: this.multiSelected.map(row => { return row.id }) })
            .then(({ data }) => {
                if (data.code === 'C0000') {
                this.$message({type: 'success', message: data.message, offset: 380, grouping: true})
                this.getListData()
                }
            })
            .finally(() => {
                this.btnsLoading.remove = false
            })
        })
    },
    //删除一个
    remove (id) {
        this.$confirm(`确定删除该数据？`, '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$post('/wmsbase/client/clientItemPrincipal/delByIds', { ids: [id]})
            .then(({ data }) => {
                if (data.code === 'C0000') {
                this.$message({type: 'success', message: data.message, offset: 380, grouping: true})
                this.getListData()
                }
            })
            .finally(() => {
                this.multiSelected =[]
            })
        })
    },
    //我要归类
    classification () {
        let row = this.multiSelected[0]
        if (row.classifyStatusDesc === '待确认') {
            return  this.$message({type: 'warning', message: '此物料存在多条归类记录，请联系商务员确认，谢谢！', offset: 380, grouping: true})
        }

        this.btnsLoading.classify = true
        this.multiSelected.map((row,idx) => {
            this.getClientItemPrincipalClassify(row, idx, this.multiSelected.length - 1)
        })
    },
    getClientItemPrincipalClassify (row, idx, sum) {
      this.$get('/wmsbase/client/clientItemPrincipal/classify', { id: row.id })
        .then(({ data }) => {
          if (data.code === 'C0000') {
            if (idx === sum) {
              setTimeout(() => {
                this.$message({type: 'success', message: data.message, offset: 380, grouping: true})
                this.getListData()
              }, 1000)
            }
          }
        })
        .finally(() => {
          if (idx === sum) {
            setTimeout(() => {
              this.btnsLoading.classify = false
            }, 1000)
          }
      })
    },
    // 导出文件
    exportFile () {
      this.btnsLoading.export = true
      this.localSearch()
    },
    handleSelect(item){
        this.dataForm.originPlaceName=item.label
    },
    //单位
    itemItemUnitName(item){
        this.dataForm.itemUnitName=item.name
        this.dataForm.itemUnitId=item.id
    },
    //产地
    changOriginPlaceName(item){
        this.dataForm.originPlaceName=item.label
        this.dataForm.originPlaceId=item.id
    },
    // 上传附件返回的临时id
    getTempBillId (id) {
        this.dataForm.tempBillId = id
    },
    // 下载模板
    downloadFile () {
        this.btnsLoading.download = true
        window.open('https://scp-static.cicsc.com/prod/template/客户端物料批导模板.xlsx')
        this.btnsLoading.download = false
    },
  },
  activated () {
    this.searchForm()
  }
};
</script>

<style lang='scss'>
.materials {
  .dividingLine {
    display: inline-block;
    width: 1px;
    height: 10px;
    background-color: #bfbfbf;
    margin: 0 5px;
  }
  .redBtn {
    margin-left: 10px !important;
  }
  .toolbar{
    display: flex;
    .file-upload-btn.multiUpload{
        margin:0 12px;
    }
  }
  //新增抽屉
  .materialsAdd {
    //滚动条的宽度
    ::-webkit-scrollbar {
        width: 8px;        
    }
    //滚动条的滑块
    ::-webkit-scrollbar-thumb {
        background-color: #aaa;
        border-radius: 3px;
        &:hover {
            background: #999;
        }
    }

    .materialsAlert{
        margin: -20px 0 20px;
    }

    .el-form-item{
        margin-bottom: 27px;
    }
    .el-drawer.rtl.open {
      border-radius: 16px;
    }
    .el-form-item__label{
        color: #000;
    }
    header {
      color: #000;
      margin-bottom: 20px;
      text-align: left;
      padding: 20px 40px 0 40px;
      h4 {
        font-size: 18px;
        font-weight: 400;
      }
    }
    .el-drawer__body{
        padding: 20px 40px;
    }
    .ab-file-upload{
        width: 100%;
        .upload{
            margin: 0;
    }
    }
   
    .el-drawer__footer {
      text-align: center;
    }
    .el-alert.el-alert--warning.is-light {
      background-color: #feeae3;
      color: #f87243;
      font-size: 14px;
      span {
        font-size: 14px;
      }
    }
  }
}
</style>